import React, { useEffect, useState } from "react";
import { getPlatforms } from "@ionic/react";
import { MailTwoTone, PhoneTwoTone } from "@ant-design/icons";

import { IonToolbar, IonLabel, IonFooter } from "@ionic/react";

import { Grid, Row, Col } from "antd";
import metaData from "../data/metaData";
const { useBreakpoint } = Grid;

//desktop
const Footer = () => {
  const screens = useBreakpoint();

  return (
    <IonFooter style={screens.md == false ? { display: "none" } : { position: "fixed", bottom: 0, width: "100%" }}>
      <Row justify="space-between" style={{ backgroundColor: "white", padding: "10px 10px 10px 15px" }}>
        <Col span={9}>
          <Row justify="start">
            <IonLabel className="footerInfo">
              <MailTwoTone style={{ fontSize: 18 }} />
              &nbsp;&nbsp;{metaData.offical.email.info}
            </IonLabel>
            <IonLabel className="footerInfo">
              <PhoneTwoTone style={{ fontSize: 18 }} />
              {metaData.offical.phone}
            </IonLabel>
          </Row>
        </Col>
        <Col span={12}>
          <Row justify="end">
            <IonLabel className="footerInfo">All right reserved by © Pearl Chinese Cuisine.</IonLabel>
            <a className="footerButton" href={metaData.offical.website.TandC} target="_blank">
              Terms of Service
            </a>
            <a className="footerButton" href={metaData.offical.website.privacy} target="_blank">
              Privacy Policy
            </a>
          </Row>
        </Col>

        {/* 
                    <IonLabel className="footerInfo">Version 1.0.8 </IonLabel> */}
      </Row>
    </IonFooter>
  );
};
export default Footer;
